<ng-container *ngIf="!needVerifyOTP">
  <section
    *ngIf="
      validToken ||
      (!validToken && tokenStatus === 'expired') ||
      (!validToken && tokenStatus === 'confirmed') ||
      (!validToken && tokenStatus === 'rejected') ||
      (!validToken && tokenStatus === 'aborted')
    "
    class="signing-layout"
  >
    <div
      [ngClass]="{ hidden: !loading }"
      class="loading"
    >
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="signing-layout__top">
      <div class="signing-layout__top-left">
        <div class="redr-logo">
          <img
            alt="cimb logo"
            src="assets/core/black-logo.svg"
          />
        </div>
        <div class="document-name">
          {{ document.name }}
        </div>
      </div>
      <div class="signing-layout__top-middle"></div>
      <div
        *ngIf="validToken"
        class="signing-layout__top-right"
      >
        <!-- <button mat-icon-button color="primary" class="btn-upload--mobile"
                        (click)="openAttachmentBottomSheet()">
                    <mat-icon [matBadgeHidden]="!uploadSelection.selected.length"
                              [matBadge]="uploadSelection.selected.length" matBadgePosition="after" matBadgeColor="warn"
                              matBadgeSize="small">
                        cloud_upload
                    </mat-icon>
                </button> -->
        <!-- <button style="margin-right: 24px;" class="btn-upload" color="primary" type="button" mat-button
                        [matMenuTriggerFor]="attachFile">
                    <mat-icon>cloud_upload</mat-icon>
                    <span class="text-color-dark" style="margin-left: 4px;">Upload Attachment</span>
                    <cimb-badge *ngIf="uploadSelection.selected.length" style="margin-left: 4px;" color="red">
                        {{uploadSelection.selected.length}}</cimb-badge>
                </button> -->
        <!-- <mat-menu #attachFile="matMenu" xPosition="before" yPosition="below"
                          class="document-signing-attachment-panel">
                    <div class="attachment-panel">
                        <div class="attachment-panel__header">

                            <span>Attachment</span>
                            <button class="add-file-btn" mat-button color="primary"
                                    (click)="$event.stopPropagation(); inputFile.click()">
                                <mat-icon>add</mat-icon>
                                <span>Add more</span>
                            </button>
                            <input class="input-file" type="file" #inputFile [multiple]="true" apUpload
                                   (click)="$event.stopPropagation()" [isUploadImmediately]="true" [isPublic]="true"
                                   [maxFiles]="maxCurrentSlot" [maxFileSize]="maxFileSize" [isReplaced]="true"
                                   (finishedFile)="onAddPhoto($event)" [apiGetUploadLink]="getUploadLink.bind(this)"
                                   [accept]="allowedMimeTypes" [allowedMimeType]="allowedMimeTypes"
                                   [allowExtensions]="allowExtensions" (fullSlot)="comfirmFullSlot()">
                        </div>
                        <mat-divider *ngIf="uploadSelection.selected.length"></mat-divider>
                        <div *ngIf="uploadSelection.selected.length" class="attachment-panel__body">
                            <div class="attachment-item" *ngFor="let attachment of uploadSelection.selected">
                                <div class="attachment-item__cell">
                                    <div class="attachment-item__icon">
                                        <mat-icon svgIcon="document"></mat-icon>
                                    </div>
                                    <p class="m-0 text-truncate "><span
                                            class="text-color-dark">{{attachment.file?.name}}</span>

                                    </p>
                                    <span class="text-color-gray">{{" (" + (attachment.file?.size | fileSize) +
                                    ")"}}</span>
                                </div>
                                <div class="attachment-item__cell attachment-item__action-cell">
                                    <button mat-icon-button
                                            (click)="$event.stopPropagation(); onRemovePhoto(attachment)">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-menu> -->

        <button
          (click)="submit()"
          *ngIf="canShowSubmitBtn"
          [class.btn-submit--mobile-hidden]="mobileBtnState === 'hidden'"
          [ngClass]="{ 'btn-submit--mobile': isMobileMode }"
          class=""
          color="primary"
          mat-flat-button
          type="button"
        >
          {{ labelSubmitBtn | titlecase }}
        </button>
        <!--                    [disabled]="(signingOnPdf && signingOnPdf.validate()) || !signingOnPdf"-->
        <button
          (click)="download()"
          *ngIf="canShowDownloadBtn === 'toolbar'"
          [ngClass]="{ 'btn-submit--mobile': isMobileMode }"
          color="primary"
          mat-button
          style="margin-left: 24px"
          type="button"
        >
          <span>Download PDF</span>
        </button>

        <ng-container *ngIf="!config?.menu?.hide">
          <button
            [matMenuTriggerFor]="menuMoreOptions"
            mat-icon-button
          >
            <mat-icon aria-hidden="true">more_horiz</mat-icon>
          </button>
          <mat-menu
            #menuMoreOptions="matMenu"
            xPosition="before"
            yPosition="below"
          >
            <button
              (click)="download()"
              *ngIf="canShowDownloadBtn === 'menu'"
              mat-menu-item
              type="button"
            >
              <span>Download</span>
            </button>
            <!-- <button *ngIf="canShowRejectBtn" type="button" mat-menu-item (click)="decline()">
                          <span>Reject</span>
                      </button> -->
          </mat-menu>
        </ng-container>
      </div>
    </div>
    <div class="signing-layout__content document-preview">
      <!--      <portal-signing-signing-on-html-->
      <!--        #signingOnHtml-->
      <!--        *ngIf="validToken && signingMode === 'html'"-->
      <!--        [document]="document"-->
      <!--        [accessToken]="accessToken"-->
      <!--        [signingTypes]="signingTypes"-->
      <!--        [tokenInfo]="accessTokenInfo"-->
      <!--        [(isMobileMode)]="isMobileMode"-->
      <!--        (mobileSubmitBtnStateChange)="onMobileSubmitBtnStateChange($event)"-->
      <!--      >-->
      <!--      </portal-signing-signing-on-html>-->
      <portal-signing-on-pdf
        #signingOnPdf
        (completed)="pdfSigningCompleted($event)"
        *ngIf="validToken && signingMode === 'pdf'"
        [(isMobileMode)]="isMobileMode"
        [accessToken]="accessToken"
        [document]="document"
        [signingTypes]="signingTypes"
        [tokenInfo]="accessTokenInfo"
      ></portal-signing-on-pdf>
      <div
        *ngIf="!validToken && tokenStatus === 'expired'"
        class="content"
      >
        <div class="success-icon">
          <img
            alt="Real Estate Doc"
            src="assets/images/expiry.svg"
          />
        </div>
        <div class="title-message">The document has been expired!</div>
        <div class="message">Please contact the sender for more details.</div>
      </div>
      <div
        *ngIf="!validToken && tokenStatus === 'rejected'"
        class="content"
      >
        <div class="success-icon">
          <img
            alt="Real Estate Doc"
            src="assets/core/e-sign/error.svg"
          />
        </div>
        <div class="title-message">The signing request has rejected!</div>
        <div class="message"></div>
      </div>
      <div
        *ngIf="!validToken && tokenStatus === 'aborted'"
        class="content"
      >
        <div class="success-icon">
          <img
            alt="Real Estate Doc"
            src="assets/core/e-sign/error.svg"
          />
        </div>
        <div class="title-message">This document was aborted!</div>
        <div class="message"></div>
      </div>
      <div
        *ngIf="!validToken && tokenStatus === 'confirmed'"
        class="content"
      >
        <div class="success-icon">
          <img
            alt="Real Estate Doc"
            src="assets/core/e-sign/done.svg"
          />
        </div>
        <div class="title-message">
          {{ accessTokenInfo.action === 'forwarder' ? 'This document was forwarded!' : 'This document was signed!' }}
        </div>
        <div class="message">
          {{
            accessTokenInfo.action === 'forwarder'
              ? 'You have forwarded this document already at '
              : 'You have signed this document already at '
          }}
          {{ this.participant.clientActionAt | datetime: formatDatetime }}.
        </div>
      </div>
    </div>
  </section>

  <section
    *ngIf="!validToken && tokenStatus === 'justSigned'"
    class="signing-successfully"
  >
    <div class="signing-successfully__content">
      <div class="red-logo">
        <img
          alt="CIMB"
          src="assets/core/black-logo.svg"
        />
      </div>
      <div class="content">
        <div class="success-icon">
          <img
            alt="CIMB"
            src="assets/core/e-sign/done.svg"
          />
        </div>
        <div class="title-message">
          {{ titleConfirm }}
        </div>
        <div class="message">
          {{ messageConfirm }}
        </div>
        <!-- <div class="go-back-btn">
                    <a href="https://realestatedoc.co/">
                        <button mat-flat-button color="primary">
                            {{ 'document.signing.visit_button' | translate }}
                        </button>
                    </a>
                </div> -->
      </div>

      <!-- Feedback section -->
      <!-- <div class="content feedback-content">
                <ng-container *ngIf="!hasSentFeedback; else doneFeedbackTemplate">
                    <form *ngIf="feedbackForm" [formGroup]="feedbackForm" fxLayout="column wrap"
                          fxLayoutAlign="center center">
                        <div fxFlexFill class="feedback-content__header">
                            <div class="feedback-content__title">
                                Feedback
                            </div>

                            <div class="feedback-content__rating">
                                <app-rating-bar formControlName="ratingScore"></app-rating-bar>
                            </div>
                        </div>

                        <div fxFlexFill class="feedback-content__comment">
                            <mat-form-field class="full-width">
                                <mat-label>Your comment - Optional</mat-label>
                                <textarea formControlName="comment" matInput></textarea>
                            </mat-form-field>
                        </div>

                        <div fxFlexFill class="feedback-content__actions">
                            <button mat-raised-button color="primary"
                                    (click)="submitFeedback()">Submit Review</button>
                        </div>
                    </form>
                </ng-container>

                <ng-template #doneFeedbackTemplate>
                    <div class="success-icon">
                        <img src="assets/images/done.svg" alt="Real Estate Doc">
                    </div>
                    <div class="message">
                        Thank you for your feedback!
                    </div>
                </ng-template>
            </div> -->
    </div>
  </section>

  <section
    *ngIf="!validToken && tokenStatus === 'readonly'"
    class="signing-layout"
  >
    <div
      [ngClass]="{ hidden: !loading }"
      class="loading"
    >
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div class="signing-layout__top">
      <div class="signing-layout__top-left">
        <div class="redr-logo">
          <img
            alt="cimb logo"
            src="assets/core/black-logo.svg"
          />
        </div>
        <div class="document-name">
          {{ document.name }}
        </div>
      </div>
      <div class="signing-layout__top-middle"></div>
    </div>
    <div class="signing-layout__content document-preview">
      <portal-signing-on-pdf
        [(isMobileMode)]="isMobileMode"
        [accessToken]="accessToken"
        [document]="document"
        [signingTypes]="signingTypes"
        [tokenInfo]="accessTokenInfo"
      ></portal-signing-on-pdf>
    </div>
  </section>
</ng-container>

<ng-container *ngIf="!document && invalidContract">
  <section class="signing-layout deleted-document">
    <div class="signing-layout__top">
      <div class="signing-layout__top-left">
        <div class="redr-logo">
          <img
            alt="cimb logo"
            src="assets/core/black-logo.svg"
          />
        </div>
        <div class="document-name">
          <span class="text-error">Removed</span>

          <span>{{ accessTokenInfo.contractName }}</span>
        </div>
      </div>
      <div class="signing-layout__top-middle"></div>
    </div>
    <div class="signing-layout__content document-preview">
      <div class="content">
        <div class="success-icon">
          <img
            alt="document-delete.svg"
            src="assets/core/e-sign/document-delete.svg"
          />
        </div>
        <div class="title-message">The document has been cancelled</div>
        <div class="message">This document is no longer available, please contact sender for more information.</div>
      </div>
    </div>
  </section>
</ng-container>
